(function () {
  'use strict';

  function initSlider(wrap) {
    var track = wrap.querySelector('.lp-proof__slider');
    var prevBtn = wrap.querySelector('[data-lp-proof-prev]');
    var nextBtn = wrap.querySelector('[data-lp-proof-next]');
    var dotsContainer = wrap.parentElement.querySelector('[data-lp-proof-dots]');
    var realCards = Array.from(track.querySelectorAll('.lp-review-card'));

    if (!track || realCards.length < 2) return;

    var totalReal = realCards.length;

    // Clone last card to start, first card to end → infinite-loop illusion
    var firstClone = realCards[0].cloneNode(true);
    var lastClone = realCards[totalReal - 1].cloneNode(true);
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    firstClone.dataset.clone = 'first';
    lastClone.dataset.clone = 'last';
    track.appendChild(firstClone);
    track.insertBefore(lastClone, track.firstChild);

    var allCards = Array.from(track.querySelectorAll('.lp-review-card'));

    // Build dots — one per real card
    realCards.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.className = 'lp-proof__dot';
      dot.setAttribute('aria-label', 'Bewertung ' + (i + 1) + ' anzeigen');
      dot.addEventListener('click', function () { scrollToRealIndex(i); });
      dotsContainer.appendChild(dot);
    });
    var dots = Array.from(dotsContainer.querySelectorAll('.lp-proof__dot'));

    function setActiveDot(realIndex) {
      dots.forEach(function (d, i) {
        d.classList.toggle('lp-proof__dot--active', i === realIndex);
      });
    }

    function centerOffset(el) {
      // Position to scrollLeft so element is centered in track
      return el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2;
    }

    function scrollToCard(allIndex, behavior) {
      var target = allCards[allIndex];
      if (!target) return;
      track.scrollTo({ left: centerOffset(target), behavior: behavior || 'smooth' });
    }

    function scrollToRealIndex(realIndex) {
      scrollToCard(realIndex + 1, 'smooth');
    }

    function getCenteredIndex() {
      var trackCenter = track.scrollLeft + track.clientWidth / 2;
      var closest = 0;
      var minDist = Infinity;
      allCards.forEach(function (card, i) {
        var cardCenter = card.offsetLeft + card.offsetWidth / 2;
        var dist = Math.abs(cardCenter - trackCenter);
        if (dist < minDist) { minDist = dist; closest = i; }
      });
      return closest;
    }

    prevBtn && prevBtn.addEventListener('click', function () {
      scrollToCard(getCenteredIndex() - 1, 'smooth');
    });
    nextBtn && nextBtn.addEventListener('click', function () {
      scrollToCard(getCenteredIndex() + 1, 'smooth');
    });

    // After scroll settles: if we're on a clone, jump (no animation) to its real counterpart
    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var idx = getCenteredIndex();
        var card = allCards[idx];
        if (!card) return;
        if (card.dataset.clone === 'first') {
          // We're on the appended clone of the first card → jump to the real first card
          scrollToCard(1, 'instant');
          setActiveDot(0);
        } else if (card.dataset.clone === 'last') {
          // We're on the prepended clone of the last card → jump to the real last card
          scrollToCard(totalReal, 'instant');
          setActiveDot(totalReal - 1);
        } else {
          setActiveDot(idx - 1);
        }
      }, 90);
    });

    // Init: center on the first real card (which is at allIndex = 1 because of prepended clone)
    requestAnimationFrame(function () {
      scrollToCard(1, 'instant');
      setActiveDot(0);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-lp-proof-slider]').forEach(initSlider);
  });
})();
